import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import * as adminActions from '../store/actions/admin.action';
import { State } from '../store/reducers';
import { PageChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AdminComponent implements OnInit {
  allBookings$: Observable<any[]>;
  // bookings: any[];
  public gridView: GridDataResult;
  public pageSize = 10;
  public skip = 0;
  constructor(private store: Store<State>) {
    store.dispatch(new adminActions.GetAllBookings());
  }

  ngOnInit() {
    this.allBookings$ = this.store.select(state => state.admin.allBookings);
    // this.allBookings$.subscribe(bookings => (this.bookings = bookings));
    // this.loadBookings();
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    // this.loadBookings();
  }

  // private loadBookings(): void {
  //   this.gridView = {
  //     data: this.bookings.slice(this.skip, this.skip + this.pageSize),
  //     total: this.bookings.length
  //   };
  // }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/admin.component.ts